// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_1d20da4b","outerContainer":"_31427ee1","secondaryToolbar":"e21e2260","doorHangerRight":"_4436bd84","toolbarContainer":"_4fa43253","toolbarViewerMiddle":"_77236aef","progressBar":"bafb11c3","back-to-application":"_78e706d9","root":"c4db3207","chatRoot":"_3f2cd0d9","avatar":"_73825302","title":"d0a7cfe4","content":"b65ba3af"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/ShareToChatModal/index.styl
// module id = 5055
// module chunks = 39